import React from 'react';
import {Card, CardDescription, CardHeader} from "../../shadCn/components/ui/card";
import {isMobile} from "../commonmethod/CommonMethod";
import {XMarkIcon} from "@heroicons/react/24/solid";

const UserList = ({users, deleteUser}) => {
    return (
        <div>
            {users && users.length > 0 && users.map((user, index) => (
                <Card className={`w-full h-[35px] pt-[5px] bg-${index % 2 === 0 ? 'even' : 'odd'}`} key={index}>
                    <CardHeader className={"p-1"}>
                        <div className={"flex justify-between w-full"}>
                            <div className={"flex gap-3"}>
                                {deleteUser &&
                                    <div className={"flex items-center cursor-pointer "} onClick={() => deleteUser(user)}>
                                        <XMarkIcon className={"h-4 w-4 text-[#e53939]"}/>
                                    </div>
                                }
                                <CardDescription className={"text-breaker w-[4rem]"}>{user.name}</CardDescription>
                                <div className={"w-[10rem] truncate"}>{user?.company ? `[${user.company.name}]` : ""}</div>
                            </div>
                            {!isMobile &&
                                <div className={'mr-2'}>
                                    <CardDescription>{user.department ? user.department.name : ""}</CardDescription>
                                </div>
                            }
                        </div>
                    </CardHeader>
                </Card>
            ))}
        </div>
    );
};

export default UserList;